import React, { Component } from 'react'
import {Button} from 'reactstrap'
import { updatePassword } from '../actions/account'

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
  isSubmitting: false
}

class PasswordChangeForm extends Component {
  constructor (props) {
    super(props)
    this.state = { ...INITIAL_STATE }
  }

  onSubmit = event => {
    event.preventDefault()

    const { passwordOne } = this.state

    this.setState({isSubmitting: true})
    updatePassword(passwordOne)
      .then(() => this.setState({ ...INITIAL_STATE }))
      .catch(error => this.setState({error, isSubmitting: false}))
  }

  render () {
    const {
      passwordOne,
      passwordTwo,
      error,
    } = this.state

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      this.state.isSubmitting

    return (
      <form onSubmit={this.onSubmit}>
        { error && <p>{error.message}</p> }

        <div className="form-group row">
          <label
            htmlFor='passwordOne'
            className="col-sm-4 col-form-label">
            Neues Passwort
          </label>

          <div className="col-sm-8">
            <input
              className='form-control'
              value={passwordOne}
              onChange={event => this.setState({passwordOne: event.target.value})}
              type="password"
              placeholder="Neues Passwort"/>
            <br/>
            <input
              className='form-control'
              value={passwordTwo}
              onChange={event => this.setState({passwordTwo: event.target.value})}
              type="password"
              placeholder="Passwort wiederholen"
            />
            <br/>
            <Button disabled={isInvalid} color="primary" className="float-right">
              {this.state.isSubmitting ? 'Bitte warten...' : 'Passwort aktualisieren'}
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default PasswordChangeForm



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/PasswordChangeForm.js